import React from "react";
import {Link, useLocation} from "react-router-dom";
import {getImagePath} from "../../utils/Functions";
import Utils from "../../utils/Utils";
import {useSelector} from "react-redux";

const Footer = (props) => {
    const location = useLocation();
    const {defConfig, params, defLang} = useSelector((state) => state.Login);
    return (Utils.excludeFooter.indexOf(location.pathname) >= 0 ? "" :
            <>
                <footer className="main" style={{background: defConfig.backgroundfooter}}>
                    {/*
                <section className="newsletter p-10 text-white wow fadeIn animated">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7 mb-md-3 mb-lg-0">
                                <div className="row align-items-center">
                                    <div className="col flex-horizontal-center">

                                        <h4 style={{ color: defConfig.headercolor1 }} className="font-size-20 mb-0 ml-3">
                                        	<i  className= "fi-rs-envelope mr-5" ></i>
                                          Suscr&iacute;bete al Bolet&iacute;n de Noticias
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-5">
                                <form className="form-subcriber d-flex wow fadeIn animated">
                                    <input
                                        type="email"
                                        className="form-control bg-white font-small"
                                        placeholder="Ingresa tu correo"
                                    />
                                    <button
                                        className="btn bg-dark text-white"
                                        type="submit"
                                    >
                                        Suscr&iacute;bete
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                */}
                    <section className="section-padding footer-mid" style={{
                        paddingTop: '40px',
                        paddingBottom: '30px'
                    }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 col-sm-12 mb-4 mb-lg-0">
                                    <div className="widget-about font-md">
                                        <div className="logo footer-logo wow fadeIn animated mb-3">
                                            <a href="/">
                                                <img
                                                    style={{
                                                        width: defConfig.imagefooterwidth,
                                                        minWidth: defConfig.imagefooterwidth,
                                                        maxWidth: '100%',
                                                        height: 'auto'
                                                    }}
                                                    src={getImagePath(defConfig.logoimagefooter)}
                                                    alt={"logo"}
                                                />
                                            </a>
                                        </div>
                                        <p style={{
                                            color: defConfig.headercolor1,
                                            fontSize: '16px',
                                            lineHeight: '1.5',
                                            marginBottom: '8px'
                                        }} className="wow fadeIn animated">
                                            Oficina central Calle 20 No 7720,
                                        </p>
                                        <p style={{
                                            color: defConfig.headercolor1,
                                            fontSize: '16px',
                                            lineHeight: '1.5',
                                            marginBottom: '15px'
                                        }} className="wow fadeIn animated">
                                            Calacoto La Paz, Bolivia.
                                        </p>
                                        <a style={{
                                            color: "#eaeaea",
                                            fontSize: '15px',
                                            textDecoration: 'none'
                                        }} href="https://www.unicef.org/bolivia/"
                                           target="_blank" rel="noreferrer">www.unicef.org/bolivia</a>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4 mb-md-0">
                                    <h5 style={{
                                        color: defConfig.headercolor1,
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        marginBottom: '20px'
                                    }} className="widget-title wow fadeIn animated">
                                        MENU
                                    </h5>
                                    <ul className="footer-list wow fadeIn animated" style={{
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0
                                    }}>
                                        <li style={{marginBottom: '10px'}}>
                                            <a href="/" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>INICIO</a>
                                        </li>
                                        <li style={{marginBottom: '10px'}}>
                                            <a href="/nuestro-equipo" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>Nuestro Equipo</a>
                                        </li>
                                        <li style={{marginBottom: '10px'}}>
                                            <a href="/aviso-de-privacidad" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>Políticas de privacidad</a>
                                        </li>
                                        <li style={{marginBottom: '10px'}}>
                                            <a href="/informe2024" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>Informe 2024</a>
                                        </li>
                                        {/*<li style={{marginBottom: '10px'}}>*/}
                                        {/*    <a href="/terminos-del-concurso" style={{*/}
                                        {/*        fontSize: '15px',*/}
                                        {/*        lineHeight: '1.6',*/}
                                        {/*        textDecoration: 'none'*/}
                                        {/*    }}>Términos del concurso</a>*/}
                                        {/*</li>*/}
                                    </ul>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <h5 style={{
                                        color: defConfig.headercolor1,
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        marginBottom: '20px'
                                    }} className="widget-title wow fadeIn animated">
                                        CONTACTOS
                                    </h5>
                                    <ul className="footer-list wow fadeIn animated" style={{
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0
                                    }}>
                                        <li style={{marginBottom: '12px'}}>
                                            <a href="tel:800109333" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>Línea Gratuita: 800 10 9333</a>
                                        </li>
                                        <li style={{marginBottom: '12px'}}>
                                            <a href="https://api.whatsapp.com/send?phone=59171543277&amp;text=Quiero%20saber%20mas%20informaci%C3%B3n%20para%20donar&quot;" rel="noreferrer" target="_blank" style={{
                                                fontSize: '15px',
                                                lineHeight: '1.6',
                                                textDecoration: 'none'
                                            }}>
                                                <strong>WhatsApp: </strong> +591 71543277
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="container pb-10 wow fadeIn animated">
                        <div className="row">
                            <div className="col-12 mb-10">
                                <div className="footer-bottom"></div>
                            </div>
                            <div className="col-lg-12">
                                <p style={{
                                    color: defConfig.headercolor1,
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    margin: 0,
                                    padding: '10px 0'
                                }} className="mb-0">
                                    Políticas de privacidad | 2025
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
    );
};
Footer.propTypes = {};

export default Footer;
